import SEO from "../components/SEO";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/Reveal";

function LegalBlock({ title, children }) {
  return (
    <Reveal>
      <div className="mb-10">
        <h2 className="font-heading uppercase font-semibold tracking-tight text-navy text-xl sm:text-2xl mb-3">{title}</h2>
        <div className="text-navy/75 text-sm sm:text-base leading-relaxed space-y-2">{children}</div>
      </div>
    </Reveal>
  );
}

function Todo() {
  return (
    <span className="inline-block bg-rouge/10 text-rouge text-xs font-bold uppercase tracking-wider px-2 py-0.5 mx-1">
      À compléter
    </span>
  );
}

export function MentionsLegales() {
  return (
    <>
      <SEO title="Mentions légales" description="Mentions légales du site du Club Cycliste Le Boulou." />
      <PageHeader kicker="Informations légales" title="Mentions légales" />
      <section className="py-16 sm:py-24">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <LegalBlock title="Éditeur du site">
            <p>Club Cycliste Le Boulou — association<Todo />(forme juridique et numéro RNA à compléter).</p>
            <p>Siège : 1 avenue du Stade, Complexe des Échards, 66160 Le Boulou, France.</p>
            <p>Contact : <a href="mailto:ccleboulou@live.fr" className="text-rouge hover:underline">ccleboulou@live.fr</a> — 07 82 85 46 99</p>
          </LegalBlock>
          <LegalBlock title="Directeur de la publication">
            <p>Le président du Club Cycliste Le Boulou<Todo />(nom à compléter).</p>
          </LegalBlock>
          <LegalBlock title="Hébergement">
            <p>Site hébergé par<Todo />(hébergeur à compléter).</p>
          </LegalBlock>
          <LegalBlock title="Propriété intellectuelle">
            <p>
              L'ensemble des contenus du site (textes, visuels, logo) est la propriété du Club Cycliste Le Boulou, sauf
              mention contraire. Toute reproduction sans autorisation est interdite.
            </p>
          </LegalBlock>
        </div>
      </section>
    </>
  );
}

export function PolitiqueConfidentialite() {
  return (
    <>
      <SEO title="Politique de confidentialité" description="Politique de confidentialité du site du Club Cycliste Le Boulou." />
      <PageHeader kicker="Vos données" title="Confidentialité" />
      <section className="py-16 sm:py-24">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <LegalBlock title="Données collectées">
            <p>
              Le formulaire de contact collecte votre nom, votre adresse email et votre message, uniquement pour
              répondre à votre demande. Aucune donnée n'est transmise à des tiers.
            </p>
          </LegalBlock>
          <LegalBlock title="Espace licencié (à venir)">
            <p>
              Lors de l'ouverture de l'espace licencié, les données nécessaires à la gestion des licences, cotisations
              et inscriptions seront traitées par le club dans le respect du RGPD. Cette page sera alors mise à jour.
            </p>
          </LegalBlock>
          <LegalBlock title="Vos droits">
            <p>
              Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos
              données. Pour l'exercer, contactez le club via le formulaire de contact.
            </p>
          </LegalBlock>
          <LegalBlock title="Cookies">
            <p>Le site n'utilise pas de cookies publicitaires. Des cookies techniques peuvent être utilisés pour le fonctionnement de l'espace licencié.<Todo />(à préciser lors de la mise en production).</p>
          </LegalBlock>
        </div>
      </section>
    </>
  );
}
